module.exports = __webpack_public_path__ + "static/media/iconImage.472daead.svg";